import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import color from "../_style/color";

export const ConfigNavigationItem = styled.li.attrs((props) => ({
  isActive: props.isActive || false,
  height: props.height || "40px",
}))`
  display: flex;
  align-items: center;
  padding: 0 8px;
  border: 1px solid ${color.gainsboro};
  border-bottom: 0 solid;
  transition: background 0.3s;
  background: ${color.light};
  cursor: pointer;
  position: relative;
  height: ${({ height }) => height};

  :hover {
    transition: background 0.3s;
    background: ${color.aliceBlue};
    border-right: 5px solid ${color.primary};
  }

  :first-of-type {
    border-radius: 2px 2px 0 0;
  }

  :last-of-type {
    border-radius: 0 0 2px;
    border-bottom: 1px solid ${color.gainsboro};
  }

  > * {
    color: ${color.highempahis};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-right: 5px solid ${color.primary};
      background: ${color.aliceBlue};
    `}
`;

ConfigNavigationItem.propTypes = {
  isActive: PropTypes.bool,
  height: PropTypes.string,
};

ConfigNavigationItem.defaultProps = {
  isActive: false,
  height: "40px",
};

export default ConfigNavigationItem;
